import { mainBlue, white } from "@u4i/styles/styles-variables";
import * as React from "react";
import { opacity7 } from "../../constants/Constants";
import { mapModuleStyling } from "../../constants/StaticMethods";

interface IPropTypes {
  cx: number
  cy: number
  isCompleted: boolean
  radius: number
  required: boolean
  title: string
  onModuleHover: (cx: number, cy: number, title: string, hoverIn: boolean) => void 
  showModuleInVE: () => void
}

export const OnlineCourseChapterIcon = (props: IPropTypes) => {
  const {
    cx,
    cy,
    isCompleted,
    radius,
    required,
    title,
    onModuleHover,
    showModuleInVE
  } = props;

  const [opacity, setOpacity] = React.useState<boolean>(false);

  const handleOpacity = () => {
    opacity ? setOpacity(false) : setOpacity(true);
  }

  const moduleHover = (mouseEnter: boolean) => {
    onModuleHover(cx, cy, title, mouseEnter);
  }

  return (
    <svg>
      <g
        onClick={showModuleInVE}
        onMouseEnter={() => { handleOpacity(); moduleHover(true); }}
        onMouseLeave={() => { handleOpacity(); moduleHover(false); }}
        style={{ cursor: "pointer", ...(opacity && { opacity: opacity7 }) }}
      >
        <circle
          cx={cx}
          cy={cy}
          r={isCompleted ? radius : radius-3}
          style={mapModuleStyling(isCompleted)}
        >
        </circle>
        <g fill={isCompleted ? white : mainBlue}>
          <path
            d={`m ${cx+13.5},${cy-11.5} c -9.061549,0.0062 -18.123608,-0.01247 -27.184837,0.0094 -1.239843,0.161465 -1.381602,1.636956 -1.269174,2.632704 0.0083,5.567692 -0.01671,11.136303 0.01257,16.703418 0.184521,1.235369 1.661617,1.342827 2.655173,1.24224 3.104303,0 6.208606,0 9.312909,0 0,0.735277 0,1.470553 0,2.20583 -1.247984,0 -2.495968,0 -3.743952,0 0,0.735275 0,1.47055 0,2.205825 4.492739,0 8.985479,0 13.478218,0 0,-0.735275 0,-1.47055 0,-2.205825 -1.247981,0 -2.495962,0 -3.743943,0 0,-0.735277 0,-1.470553 0,-2.20583 3.570422,-0.0062 7.141354,0.01245 10.711456,-0.0094 1.239837,-0.161477 1.381611,-1.636951 1.269184,-2.632704 0,-5.491702 0,-10.983405 0,-16.475107 0.01775,-0.792152 -0.711517,-1.492235 -1.497608,-1.470546 z m -0.748739,18.381892 c -8.486295,0 -16.972589,0 -25.458884,0 0,-5.392023 0,-10.784047 0,-16.17607 8.486295,0 16.972589,0 25.458884,0 0,5.392023 0,10.784047 0,16.17607 z`}
            style={{strokeWidth: 0.7}}
          />
          <path
            d={`m ${cx-7.5},${cy+2.5} c 2.537193,-0.06119 5.155534,0.466867 7.295945,1.881249 0.700125,0.152866 1.476102,0.152422 2.084555,-0.2754 2.086711,-1.205859 4.528212,-1.649315 6.916695,-1.619672 0.666692,-0.642646 0.01179,-1.642881 0.119496,-2.44133 -0.132776,-1.45531 -0.265542,-2.91062 -0.398307,-4.365931 -0.380197,-0.397336 -1.117119,-0.575282 -0.79962,-1.29736 -0.326056,-0.432727 -1.481504,0.222851 -1.242201,-0.734643 -0.03278,-0.829414 -1.002888,-0.541392 -1.552962,-0.574834 -1.614382,0.09698 -3.185358,0.805037 -4.322489,1.955899 -1.482947,-1.503792 -3.717612,-2.250908 -5.802809,-1.867963 0.110714,0.60004 -0.180632,1.438546 -0.926006,1.003129 -0.716686,0.05698 -0.06232,1.368403 -0.933571,1.215029 -0.556427,0.598297 -0.224916,1.531044 -0.43204,2.265892 -0.136369,1.503267 -0.282921,3.005651 -0.404893,4.510191 0.02071,0.192446 0.201452,0.358913 0.398207,0.345744 z m 8.442149,-6.836914 c 1.220077,-1.309018 3.044382,-2.03355 4.830655,-1.900768 0.175704,2.066919 0.351415,4.133838 0.527127,6.200757 -1.969996,0.363859 -3.837123,1.260901 -5.357782,2.564282 0,-2.28809 0,-4.576181 0,-6.864271 z m 0,7.812932 c 1.615094,-1.638782 3.824095,-2.620975 6.090881,-2.919529 -0.159315,-1.875175 -0.318622,-3.750351 -0.47793,-5.625527 0.968834,-0.112097 0.435077,1.331014 0.683511,1.910703 0.132641,1.438875 0.265282,2.87775 0.39793,4.316624 -2.417351,0.06296 -4.80315,0.938816 -6.694392,2.444245 0,-0.04216 0,-0.08441 0,-0.126516 z m -5.511683,-9.711496 c 1.785375,-0.123135 3.60456,0.598415 4.831362,1.899062 0,2.288026 0,4.576053 0,6.864079 -1.520748,-1.303551 -3.388044,-2.200678 -5.358207,-2.564588 0.175615,-2.066184 0.351241,-4.132368 0.526845,-6.198553 z m -1.286148,1.13405 c 1.009454,0.08444 0.165033,1.45535 0.327843,2.108699 -0.100518,1.183234 -0.201056,2.366466 -0.301593,3.549699 2.267948,0.29467 4.47668,1.280037 6.09126,2.919386 -0.67069,-0.170031 -1.095688,-0.803378 -1.75402,-1.017692 -1.519136,-0.80204 -3.223122,-1.25356 -4.940781,-1.300293 0.192417,-2.086601 0.38486,-4.173199 0.577291,-6.259799 z`}
            style={{strokeWidth: 0.5}}
          />
          <path
            d={`m ${cx+1.5},${cy-0.5} c 0,0.374945 0,0.749889 0,1.124834 1.074173,-0.88127 2.293306,-1.588998 3.600001,-2.063711 -0.02077,-0.313687 -0.04152,-0.627375 -0.06234,-0.941059 -1.266122,0.441135 -2.459617,1.08441 -3.537661,1.879936 z`}
            style={{strokeWidth: 0.5}}
          />
          <path
            d={`m ${cx+5},${cy-5} c -1.258742,0.445038 -2.450477,1.075973 -3.532827,1.85702 0,0.382583 0,0.765167 0,1.14775 1.081695,-0.865377 2.299711,-1.562441 3.600005,-2.041747 -0.0224,-0.321003 -0.04477,-0.642042 -0.06718,-0.963023 z`}
            style={{strokeWidth: 0.5}}
          />
        </g>
      </g>
    </svg>
  )
}
